import { getUserLanguage } from '@/utils/langs';
import dayjs from 'dayjs';
import { useEffect } from 'react';

import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/de';
import 'dayjs/locale/ko';
import 'dayjs/locale/ja';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/tr';
import 'dayjs/locale/uk';

export const useLocale = () => {
  useEffect(() => {
    const userLanguage = getUserLanguage();

    dayjs.locale(userLanguage);
  }, []);
};
